import { render, staticRenderFns } from "./Markdown.vue?vue&type=template&id=d953884a&scoped=true&"
import script from "./Markdown.vue?vue&type=script&lang=js&"
export * from "./Markdown.vue?vue&type=script&lang=js&"
import style0 from "./Markdown.vue?vue&type=style&index=0&id=d953884a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d953884a",
  null
  
)

component.options.__file = "Markdown.vue"
export default component.exports